module.exports = __webpack_public_path__ + "static/img/img3.499ee19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zone/img3.png
// module id = xl5t
// module chunks = 1